import moment from 'moment'

const WIDGET_FILTERS_TO_REMOVE_FROM_PARAMS = ['createdAtStart', 'createdAtEnd']

export const formatDateFilter = (date = '') => {
  return date ? moment(date).format('YYYY-MM-DD') : ''
}

export const formatDateIntervalFilter = (startDate, endDate) => {
  return startDate || endDate ? `${formatDateFilter(startDate)},${formatDateFilter(endDate)}` : ''
}

export function formatFilter(filters = null) {
  if (!filters) return null

  const filteredEntries = Object.entries(filters).filter(([key, value]) => {
    // for date filters
    if (WIDGET_FILTERS_TO_REMOVE_FROM_PARAMS.includes(key)) return false
    // for select filters
    if (value === 'all') return false
    // for text filters
    if (typeof value === 'string' && value?.trim() === '') return false
    return true
  })

  return Object.fromEntries(filteredEntries)
}
